//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class LetterClassificationService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[LetterClassification.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/aut/letter-classification/detail', {'params':params});
	};

	//GeneratorFlag:[LetterClassification.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/aut/letter-classification/list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}